import { createContext, RefObject, useContext } from 'react';
import { DAttachmentUploadMeta } from '@/src/modules/chat/data/dtos/attachment-upload-meta';

interface IChatComposerContextProps {
  content: string;
  resetFileUploadRef: RefObject<(() => void) | null>;
  attachments: DAttachmentUploadMeta[];
  setContent: (content: string) => void;
  addAttachments: (metas: DAttachmentUploadMeta[]) => void;
  removeAttachment: (id: string) => void;
  clearAttachments: () => void;
  resetState: () => void;
}

export const ChatComposerContext =
  createContext<IChatComposerContextProps | null>(null);

export function useChatComposerContext() {
  const context = useContext(ChatComposerContext);
  if (!context) {
    throw new Error(
      'useChatComposerContext must be used within a ChatComposerProvider'
    );
  }

  return context;
}
